export const status = {
  WAITING: 'WAITING',
  OVERDUE: 'OVERDUE',
  BILLED: 'BILLED',
  CANCELLED: 'CANCELLED',
  BILLANDOVERDUE: 'BILLANDOVERDUE',
  PAID: 'PAID',
  PARTIAL: 'PARTIAL',
  ALL: 'ALL',
}

export const statusText = {
  WAITING: 'รอเก็บเงิน',
  OVERDUE: 'เลยกำหนดการชำระเงิน',
  BILLED: 'นำไปสร้างบิลแล้ว',
  CANCELLED: 'ยกเลิกแล้ว',
  BILLANDOVERDUE: 'สร้างใบปะหน้า',
  PAID: 'ชำระเงินแล้ว',
  PARTIAL: 'ชำระเงินบางส่วน',
  ALL: 'ทั้งหมด',
}

export const detailMode = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  VIEW: 'VIEW',
}

export const PDRBankList = [
  {
    code: 'BCA010',
    text: 'ธนาคารกรุงเทพ สาขา ปทุมธานี 178-302-4688',
  }, {
    code: 'BCA011',
    text: 'ธนาคารกรุงเทพ สาขา ปทุมธานี 178-303-5098',
  }, {
    code: 'BSV020',
    text: 'ธนาคารกรุงเทพ สาขา ปทุมธานี 178-454-7471',
  }, {
    code: 'BCA005',
    text: 'ธนาคารกรุงเทพ สาขา ปทุมธานี 178-303-5080',
  }, {
    code: 'BCA003',
    text: 'ธนาคารกรุงไทย สาขา ปทุมธานี 1346006245',
  }, {
    code: 'BSV016',
    text: 'ธนาคารกรุงไทย สาขา สามโคก 134-114-6456',
  }, {
    code: 'BCA004',
    text: 'ธนาคารกสิกรไทย สาขา ปทุมธานี 2501045899',
  }, {
    code: 'BSV004',
    text: 'ธนาคารกสิกรไทย สาขา ปทุมธานี 250-267-0789',
  }, {
    code: 'BCA009',
    text: 'ธนาคารทหารไทย สาขา ปทุมธานี 059-105-1396',
  }, {
    code: 'BCA012',
    text: 'ธนาคารทหารไทย สาขา ปทุมธานี 059-105-1370',
  }, {
    code: 'BSV018',
    text: 'ธนาคารทหารไทย สาขา ปทุมธานี 059-208-6466',
  }, {
    code: 'BSV022',
    text: 'ธนาคารทหารไทย สาขา ปทุมธานี 059-208-6474',
  }, {
    code: 'BCA006',
    text: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ สาขา สำนักลุมพินี 8891017937',
  }, {
    code: 'BSV023',
    text: 'ธนาคารแลนด์ แอนด์ เฮ้าส์ สาขา สำนักลุมพินี 889-231-1407',
  }, {
    code: 'BCA001',
    text: 'ธนาคารไทยพาณิชย์ สาขาพระประแดง  3033026536',
  }, {
    code: 'BCA002',
    text: 'ธนาคารไทยพาณิชย์ สาขาสามโคก 3173009559',
  }, {
    code: 'BCA007',
    text: 'ธนาคารไทยพาณิชย์ สาขา พระประแดง 303-301-8559',
  }, {
    code: 'BCA008',
    text: 'ธนาคารไทยพาณิชย์ สาขา สามโคก 317-300-6959',
  }, {
    code: 'BSV017',
    text: 'ธนาคารไทยพาณิชย์ สาขา สามโคก 3172318701',
  }, {
    code: 'BSV021',
    text: 'ธนาคารไทยพาณิชย์ สาขา พระประแดง 303-226-2684',
  }, {
    code: 'BSV024',
    text: 'ธนาคารไทยพาณิชย์ สาขา สามโคก 317-243-4141',
  },
]

export const TRSBankList = [
  {
    code: 'BCA001',
    text: 'ธนาคารไทยพาณิชย์ สาขาสามโคก 3173013370',
  },
]
